import { Breadcrumbs } from "components/breadcrumbs";
import { useOne, useParse, useUpdate } from "@refinedev/core";
import { FullScreenLoading } from "components/fullScreenLoading";
import { IBlogSubCategoryForm, IBlogSubCategoryItem } from "interfaces";
import { BlogSubCategoryForm } from "./components";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";

export const EditBlogSubCategory: React.FC = () => {
  const parse = useParse();
  const { params } = parse();
  const { mutate, isLoading: isUpdatingSubCategory } = useUpdate();
  const navigate = useNavigate();

  const {
    data,
    isFetching,
    isPreviousData,
    isLoading,
  } = useOne<IBlogSubCategoryItem>({
    resource: "mkt/sub-categories",
    id: params?.id,
    meta: {
      resource: "data",
    },
    queryOptions: {
      enabled: !!params?.id,
    } as any,
  });


	const onSubmit = (values: IBlogSubCategoryForm) => {
    const submitValues = { ...values };
		const id = params?.id;
		if (id) {
			mutate(
				{
					resource: "mkt/sub-categories",
					id: id,
					meta: {
						ignoreResourceWrapper: true,
					},
					values: {
						...submitValues,
					},
				},
				{
					onSuccess: () => {
						toast.success("Edit successfully");
						navigate(`/mkt/sub-category/${id}`);
					},
				}
			);	
		}
  };

  const blogSubCategoryDetail = data?.data ?? null;

  if (isLoading) {
    return <FullScreenLoading />;
  }

  return (
    <div className="wrapper">
      <Breadcrumbs customPageLabel="Edit Blogs - Sub categories" />
      {blogSubCategoryDetail ? (
        <BlogSubCategoryForm
          defaultData={blogSubCategoryDetail}
          id={params?.id}
					onSubmit={onSubmit}
        />
      ) : (
        <></>
      )}
      {((isFetching && isPreviousData) || isUpdatingSubCategory) ? <FullScreenLoading /> : <></>}
    </div>
  );
};
